// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.other-plugins-container {
  /* Grid layout adjustments */
  /* Mobile: 1 card per row */
  /* Tablet and Laptop: 2 cards per row */
  /* Desktop: 3 cards per row */
  /* Plugin card styles */
  /* Small screen adjustments */
}
.other-plugins-container .row {
  display: flex;
  flex-wrap: wrap;
}
.other-plugins-container .plugin-grid-item {
  position: relative;
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-bottom: 30px;
}
@media (max-width: 767px) {
  .other-plugins-container .plugin-grid-item {
    flex: 0 0 100%;
    max-width: 100%;
  }
}
@media (min-width: 768px) {
  .other-plugins-container .plugin-grid-item {
    flex: 0 0 50%;
    max-width: 50%;
  }
}
@media (min-width: 1400px) {
  .other-plugins-container .plugin-grid-item {
    flex: 0 0 33.333333%;
    max-width: 33.333333%;
  }
}
.other-plugins-container .plugin-card {
  width: 100%;
  height: 100%;
  font-family: "Roboto", sans-serif;
  border: 1px solid #d8d9db;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  background: #fff;
}
.other-plugins-container .top-section {
  background: #ffffff;
  padding: 16px;
  display: flex;
  gap: 16px;
  border-bottom: 1px solid #d8d9db;
  align-items: flex-start;
  flex: 1;
}
.other-plugins-container .pl-icon img {
  display: block;
  width: 80px;
  height: 80px;
}
.other-plugins-container .plugin-info {
  flex: 1;
  display: flex;
  justify-content: space-between;
  min-width: 0; /* Helps prevent overflow */
}
.other-plugins-container .info-container {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.other-plugins-container .plugin-title {
  font-size: 16px;
  line-height: 22px;
  font-weight: 600;
  color: #2271b1;
  margin: 0;
  word-break: break-word;
}
.other-plugins-container .plugin-description {
  font-size: 13px;
  line-height: 18px;
  color: #3c434a;
  margin: 0;
}
.other-plugins-container .plugin-author {
  font-size: 13px;
  line-height: 18px;
  color: #2c3338;
  margin: 0;
}
.other-plugins-container .ac-buttons {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 85px;
  min-width: 85px;
}
.other-plugins-container .install-button {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 5px;
  border: 1px solid #2271b1 !important;
  border-radius: 3px;
  color: #2271b1 !important;
  background: transparent;
  font-size: 13px !important;
  line-height: 20px;
  cursor: pointer;
  width: 100%;
  text-decoration: none;
  text-align: center;
}
.other-plugins-container .install-button:hover {
  background: #f0f0f1;
}
.other-plugins-container .install-button:disabled {
  cursor: default;
  opacity: 0.8;
}
.other-plugins-container .install-button.checking, .other-plugins-container .install-button.installing, .other-plugins-container .install-button.activating {
  color: #2271b1 !important;
  border: 1px solid #2271b1 !important;
  background-color: #f6f7f7 !important;
}
.other-plugins-container .install-button.installation_complete {
  background: #00a32a;
  color: #fff !important;
  transition: background-color 0.3s;
}
.other-plugins-container .install-button.installed {
  background: #2271b1;
  color: #fff !important;
}
.other-plugins-container .install-button.activated {
  opacity: 0.6;
  cursor: not-allowed;
}
.other-plugins-container .install-button.error {
  background: #d63638;
  color: #fff !important;
}
.other-plugins-container .more-details {
  color: #2271b1 !important;
  text-decoration: none;
  font-size: 13px !important;
  line-height: 20px;
  text-align: center;
}
.other-plugins-container .more-details:hover {
  color: #135e96;
}
.other-plugins-container .plugin-error-message {
  color: #d63638;
  background-color: #fcf0f1;
  padding: 8px 12px;
  border-left: 4px solid #d63638;
  margin-top: 10px;
  font-size: 13px;
}
.other-plugins-container .bottom-section {
  background: #f6f7f7;
  padding: 12px 16px;
  display: flex;
  justify-content: space-between;
}
.other-plugins-container .rating-section {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.other-plugins-container .stars-container {
  display: flex;
  align-items: center;
  gap: 4px;
}
.other-plugins-container .stars {
  display: flex;
  gap: 2px;
}
.other-plugins-container .rating-count {
  font-size: 13px;
  line-height: 20px;
  color: #3c434a;
}
.other-plugins-container .installation-count {
  font-size: 13px;
  line-height: 20px;
  color: #3c434a;
  margin: 0;
}
.other-plugins-container .update-info {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.other-plugins-container .last-updated {
  display: flex;
  gap: 4px;
}
.other-plugins-container .update-label {
  font-size: 13px;
  line-height: 20px;
  font-weight: 600;
  color: #3c434a;
}
.other-plugins-container .update-time {
  font-size: 13px;
  line-height: 20px;
  color: #3c434a;
}
.other-plugins-container .compatibility {
  font-size: 13px;
  line-height: 20px;
  color: #3c434a;
  margin: 0;
}
.other-plugins-container .author-name {
  color: #2271b1;
  font-size: 13px;
  line-height: 20px;
  text-decoration: none;
}
.other-plugins-container .author-name:hover {
  text-decoration: underline;
}
@media (max-width: 575px) {
  .other-plugins-container .top-section {
    flex-direction: column;
    align-items: center;
    text-align: center;
    padding: 12px;
  }
  .other-plugins-container .pl-icon {
    margin-bottom: 10px;
  }
  .other-plugins-container .plugin-info {
    flex-direction: column;
    width: 100%;
  }
  .other-plugins-container .info-container {
    text-align: center;
    align-items: center;
    margin-bottom: 10px;
  }
  .other-plugins-container .ac-buttons {
    width: 100%;
    flex-direction: row;
    justify-content: center;
  }
  .other-plugins-container .bottom-section {
    flex-direction: column;
    align-items: center;
    text-align: center;
    gap: 10px;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/other-plugins/PluginCard.scss"],"names":[],"mappings":"AAAA;EACC,4BAAA;EAcA,2BAAA;EAQA,uCAAA;EAQA,6BAAA;EAQA,uBAAA;EAoOA,6BAAA;AApQD;AALC;EACC,aAAA;EACA,eAAA;AAOF;AAJC;EACC,kBAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;AAMF;AAFC;EACC;IACC,cAAA;IACA,eAAA;EAID;AACF;AAAC;EACC;IACC,aAAA;IACA,cAAA;EAED;AACF;AAEC;EACC;IACC,oBAAA;IACA,qBAAA;EAAD;AACF;AAIC;EACC,WAAA;EACA,YAAA;EACA,iCAAA;EACA,yBAAA;EACA,sBAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;AAFF;AAKC;EACC,mBAAA;EACA,aAAA;EACA,aAAA;EACA,SAAA;EACA,gCAAA;EACA,uBAAA;EACA,OAAA;AAHF;AAMC;EACC,cAAA;EACA,WAAA;EACA,YAAA;AAJF;AAOC;EACC,OAAA;EACA,aAAA;EACA,8BAAA;EACA,YAAA,EAAA,2BAAA;AALF;AAQC;EACC,OAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AANF;AASC;EACC,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;EACA,sBAAA;AAPF;AAUC;EACC,eAAA;EACA,iBAAA;EACA,cAAA;EACA,SAAA;AARF;AAWC;EACC,eAAA;EACA,iBAAA;EACA,cAAA;EACA,SAAA;AATF;AAYC;EACC,aAAA;EACA,sBAAA;EACA,QAAA;EACA,WAAA;EACA,eAAA;AAVF;AAaC;EACC,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,oCAAA;EACA,kBAAA;EACA,yBAAA;EACA,uBAAA;EACA,0BAAA;EACA,iBAAA;EACA,eAAA;EACA,WAAA;EACA,qBAAA;EACA,kBAAA;AAXF;AAaE;EACC,mBAAA;AAXH;AAcE;EACC,eAAA;EACA,YAAA;AAZH;AAgBE;EAGC,yBAAA;EACA,oCAAA;EACA,oCAAA;AAhBH;AAkBE;EACC,mBAAA;EACA,sBAAA;EACA,iCAAA;AAhBH;AAmBE;EACC,mBAAA;EACA,sBAAA;AAjBH;AAoBE;EACC,YAAA;EACA,mBAAA;AAlBH;AAqBE;EACC,mBAAA;EACA,sBAAA;AAnBH;AAuBC;EACC,yBAAA;EACA,qBAAA;EACA,0BAAA;EACA,iBAAA;EACA,kBAAA;AArBF;AAwBC;EACC,cAAA;AAtBF;AAyBC;EACC,cAAA;EACA,yBAAA;EACA,iBAAA;EACA,8BAAA;EACA,gBAAA;EACA,eAAA;AAvBF;AA0BC;EACC,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,8BAAA;AAxBF;AA2BC;EACC,aAAA;EACA,sBAAA;EACA,QAAA;AAzBF;AA4BC;EACC,aAAA;EACA,mBAAA;EACA,QAAA;AA1BF;AA6BC;EACC,aAAA;EACA,QAAA;AA3BF;AA8BC;EACC,eAAA;EACA,iBAAA;EACA,cAAA;AA5BF;AA+BC;EACC,eAAA;EACA,iBAAA;EACA,cAAA;EACA,SAAA;AA7BF;AAgCC;EACC,aAAA;EACA,sBAAA;EACA,QAAA;AA9BF;AAiCC;EACC,aAAA;EACA,QAAA;AA/BF;AAkCC;EACC,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;AAhCF;AAmCC;EACC,eAAA;EACA,iBAAA;EACA,cAAA;AAjCF;AAoCC;EACC,eAAA;EACA,iBAAA;EACA,cAAA;EACA,SAAA;AAlCF;AAqCC;EACC,cAAA;EACA,eAAA;EACA,iBAAA;EACA,qBAAA;AAnCF;AAsCC;EACC,0BAAA;AApCF;AAwCC;EACC;IACC,sBAAA;IACA,mBAAA;IACA,kBAAA;IACA,aAAA;EAtCD;EAyCA;IACC,mBAAA;EAvCD;EA0CA;IACC,sBAAA;IACA,WAAA;EAxCD;EA2CA;IACC,kBAAA;IACA,mBAAA;IACA,mBAAA;EAzCD;EA4CA;IACC,WAAA;IACA,mBAAA;IACA,uBAAA;EA1CD;EA6CA;IACC,sBAAA;IACA,mBAAA;IACA,kBAAA;IACA,SAAA;EA3CD;AACF","sourcesContent":[".other-plugins-container {\n\t/* Grid layout adjustments */\n\t.row {\n\t\tdisplay: flex;\n\t\tflex-wrap: wrap;\n\t}\n\n\t.plugin-grid-item {\n\t\tposition: relative;\n\t\twidth: 100%;\n\t\tpadding-right: 15px;\n\t\tpadding-left: 15px;\n\t\tmargin-bottom: 30px;\n\t}\n\n\t/* Mobile: 1 card per row */\n\t@media (max-width: 767px) {\n\t\t.plugin-grid-item {\n\t\t\tflex: 0 0 100%;\n\t\t\tmax-width: 100%;\n\t\t}\n\t}\n\n\t/* Tablet and Laptop: 2 cards per row */\n\t@media (min-width: 768px) {\n\t\t.plugin-grid-item {\n\t\t\tflex: 0 0 50%;\n\t\t\tmax-width: 50%;\n\t\t}\n\t}\n\n\t/* Desktop: 3 cards per row */\n\t@media (min-width: 1400px) {\n\t\t.plugin-grid-item {\n\t\t\tflex: 0 0 33.333333%;\n\t\t\tmax-width: 33.333333%;\n\t\t}\n\t}\n\n\t/* Plugin card styles */\n\t.plugin-card {\n\t\twidth: 100%;\n\t\theight: 100%;\n\t\tfont-family: \"Roboto\", sans-serif;\n\t\tborder: 1px solid #d8d9db;\n\t\tbox-sizing: border-box;\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tbackground: #fff;\n\t}\n\n\t.top-section {\n\t\tbackground: #ffffff;\n\t\tpadding: 16px;\n\t\tdisplay: flex;\n\t\tgap: 16px;\n\t\tborder-bottom: 1px solid #d8d9db;\n\t\talign-items: flex-start;\n\t\tflex: 1;\n\t}\n\n\t.pl-icon img {\n\t\tdisplay: block;\n\t\twidth: 80px;\n\t\theight: 80px;\n\t}\n\n\t.plugin-info {\n\t\tflex: 1;\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\tmin-width: 0; /* Helps prevent overflow */\n\t}\n\n\t.info-container {\n\t\tflex: 1;\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tgap: 12px;\n\t}\n\n\t.plugin-title {\n\t\tfont-size: 16px;\n\t\tline-height: 22px;\n\t\tfont-weight: 600;\n\t\tcolor: #2271b1;\n\t\tmargin: 0;\n\t\tword-break: break-word;\n\t}\n\n\t.plugin-description {\n\t\tfont-size: 13px;\n\t\tline-height: 18px;\n\t\tcolor: #3c434a;\n\t\tmargin: 0;\n\t}\n\n\t.plugin-author {\n\t\tfont-size: 13px;\n\t\tline-height: 18px;\n\t\tcolor: #2c3338;\n\t\tmargin: 0;\n\t}\n\n\t.ac-buttons {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tgap: 8px;\n\t\twidth: 85px;\n\t\tmin-width: 85px;\n\t}\n\n\t.install-button {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\tpadding: 5px;\n\t\tborder: 1px solid #2271b1 !important;\n\t\tborder-radius: 3px;\n\t\tcolor: #2271b1 !important;\n\t\tbackground: transparent;\n\t\tfont-size: 13px !important;\n\t\tline-height: 20px;\n\t\tcursor: pointer;\n\t\twidth: 100%;\n\t\ttext-decoration: none;\n\t\ttext-align: center;\n\n\t\t&:hover {\n\t\t\tbackground: #f0f0f1;\n\t\t}\n\n\t\t&:disabled {\n\t\t\tcursor: default;\n\t\t\topacity: 0.8;\n\t\t}\n\n\t\t// WordPress-like spinner animation\n\t\t&.checking,\n\t\t&.installing,\n\t\t&.activating {\n\t\t\tcolor: #2271b1 !important; \n\t\t\tborder: 1px solid #2271b1 !important;\n\t\t\tbackground-color: #f6f7f7 !important; \n\t\t}\n\t\t&.installation_complete {\n\t\t\tbackground: #00a32a; \n\t\t\tcolor: #fff !important;\n\t\t\ttransition: background-color 0.3s;\n\t\t  }\n\n\t\t&.installed {\n\t\t\tbackground: #2271b1;\n\t\t\tcolor: #fff !important;\n\t\t}\n\n\t\t&.activated {\n\t\t\topacity: 0.6;\n\t\t\tcursor: not-allowed;\n\t\t}\n\n\t\t&.error {\n\t\t\tbackground: #d63638;\n\t\t\tcolor: #fff !important;\n\t\t}\n\t}\n\n\t.more-details {\n\t\tcolor: #2271b1 !important;\n\t\ttext-decoration: none;\n\t\tfont-size: 13px !important;\n\t\tline-height: 20px;\n\t\ttext-align: center;\n\t}\n\n\t.more-details:hover {\n\t\tcolor: #135e96;\n\t}\n\n\t.plugin-error-message {\n\t\tcolor: #d63638;\n\t\tbackground-color: #fcf0f1;\n\t\tpadding: 8px 12px;\n\t\tborder-left: 4px solid #d63638;\n\t\tmargin-top: 10px;\n\t\tfont-size: 13px;\n\t}\n\n\t.bottom-section {\n\t\tbackground: #f6f7f7;\n\t\tpadding: 12px 16px;\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t}\n\n\t.rating-section {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tgap: 4px;\n\t}\n\n\t.stars-container {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tgap: 4px;\n\t}\n\n\t.stars {\n\t\tdisplay: flex;\n\t\tgap: 2px;\n\t}\n\n\t.rating-count {\n\t\tfont-size: 13px;\n\t\tline-height: 20px;\n\t\tcolor: #3c434a;\n\t}\n\n\t.installation-count {\n\t\tfont-size: 13px;\n\t\tline-height: 20px;\n\t\tcolor: #3c434a;\n\t\tmargin: 0;\n\t}\n\n\t.update-info {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tgap: 8px;\n\t}\n\n\t.last-updated {\n\t\tdisplay: flex;\n\t\tgap: 4px;\n\t}\n\n\t.update-label {\n\t\tfont-size: 13px;\n\t\tline-height: 20px;\n\t\tfont-weight: 600;\n\t\tcolor: #3c434a;\n\t}\n\n\t.update-time {\n\t\tfont-size: 13px;\n\t\tline-height: 20px;\n\t\tcolor: #3c434a;\n\t}\n\n\t.compatibility {\n\t\tfont-size: 13px;\n\t\tline-height: 20px;\n\t\tcolor: #3c434a;\n\t\tmargin: 0;\n\t}\n\n\t.author-name {\n\t\tcolor: #2271b1;\n\t\tfont-size: 13px;\n\t\tline-height: 20px;\n\t\ttext-decoration: none;\n\t}\n\n\t.author-name:hover {\n\t\ttext-decoration: underline;\n\t}\n\n\t/* Small screen adjustments */\n\t@media (max-width: 575px) {\n\t\t.top-section {\n\t\t\tflex-direction: column;\n\t\t\talign-items: center;\n\t\t\ttext-align: center;\n\t\t\tpadding: 12px;\n\t\t}\n\n\t\t.pl-icon {\n\t\t\tmargin-bottom: 10px;\n\t\t}\n\n\t\t.plugin-info {\n\t\t\tflex-direction: column;\n\t\t\twidth: 100%;\n\t\t}\n\n\t\t.info-container {\n\t\t\ttext-align: center;\n\t\t\talign-items: center;\n\t\t\tmargin-bottom: 10px;\n\t\t}\n\n\t\t.ac-buttons {\n\t\t\twidth: 100%;\n\t\t\tflex-direction: row;\n\t\t\tjustify-content: center;\n\t\t}\n\n\t\t.bottom-section {\n\t\t\tflex-direction: column;\n\t\t\talign-items: center;\n\t\t\ttext-align: center;\n\t\t\tgap: 10px;\n\t\t}\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
